<template>
  <div
    v-if="hasToShowOnboarding"
    ref="onboardingPanel"
    class="onboarding-panel onboarding-panel-size border-radius-small d-flex"
    :class="{
      'panel-size-increased-on-select-plan-isLifetime': hasToShowSelectPlanStep,
      'panel-size-increased-on-checkout align-start overflow-y': hasToShowCheckoutStep,
      'panel-size-increased-on-specialties': hasToShowSpecialtyStep,
      'no-top-left': hasToShowKeywordsPanel && $breakpoint.mobileAndDown,
      'panel-size-increased-on-keywords': hasToShowKeywordsPanel,
      'panel-size-increased-on-ethics': hasToShowEthicsPanel,
    }"
  >
    <v-row
      v-if="hasToShowWelcomeSteps"
      no-gutters
      class="justify-space-around fix-last-step-overflow pa-6 pa-sm-10 mb-0"
      :class="{ 'align-content-start': $breakpoint.mobileAndDown }"
    >
      <v-col
        class="col-sm-4 col-lg-auto text-center"
        :class="[
          { 'adjust-images-for-tablet-and-up': $breakpoint.tabletAndUp },
          hasToAdjustImagesHeadingForSEPhones ? 'mb-4 mt-2' : 'col-12',
        ]"
      >
        <OnboardingImagesHandlerComponent
          :current-step-index="currentStepIndex"
          :enum-steps="enumOnboarding"
        />
      </v-col>
      <v-col
        v-if="hasToAdjustImagesHeadingForSEPhones"
        class="align-self-center"
      >
        <v-row
          no-gutters
          align="center"
        >
          <div
            v-show="currentStepIndex > enumOnboarding.INTRO && currentStepIndex < enumOnboarding.SELECT_PLAN_STEP"
            class="heading number-step-box mr-2 primary--text"
            :class="calculateClassForNumber"
          >
            <span>{{ currentStepIndex }}</span>
          </div>
          <h3
            class="heading primary--text"
            :class="titleClassName"
          >
            {{ titleForSteps }}
          </h3>
        </v-row>
      </v-col>
      <v-col class="content-onboarding col-12 col-sm-8 col-lg pl-sm-3 py-0">
        <v-row
          v-if="!hasToAdjustImagesHeadingForSEPhones"
          no-gutters
          align="center"
        >
          <div
            v-show="currentStepIndex > enumOnboarding.INTRO && currentStepIndex < enumOnboarding.SELECT_PLAN_STEP"
            class="heading number-step-box mr-2 primary--text"
            :class="calculateClassForNumber"
          >
            <span>{{ currentStepIndex }}</span>
          </div>
          <h3
            class="heading primary--text mt-1 mt-sm-0"
            :class="titleClassName"
          >
            {{ titleForSteps }}
          </h3>
        </v-row>
        <v-row no-gutters>
          <p
            ref="descriptions"
            class="descriptions mt-2 mb-4 text text-l-large-regular word-wrap-all"
            :class="{
              'pl-sm-15 pl-lg-8': !$breakpoint.mobileAndDown && currentStepIndex === enumOnboarding.SELECT_PLAN_STEP,
            }"
            v-html="items[currentStepIndex].desc"
          />
        </v-row>
        <v-row
          no-gutters
          class="mt-sm-0 pl-sm-3"
          justify-sm="space-between"
          :class="[
            currentStepIndex === enumOnboarding.SELECT_PLAN_STEP ? 'mt-0' : '',
            {
              'fixed-bottom-mobile': $breakpoint.mobileAndDown,
              'fixed-actions-nonmobile': $breakpoint.tabletAndUp,
            },
          ]"
        >
          <v-col
            v-show="currentStepIndex < enumOnboarding.SELECT_PLAN_STEP && $breakpoint.tabletAndUp"
            cols="12"
            sm="auto"
            align-self="center"
          >
            <div class="d-flex">
              <DotComponent
                v-for="index in 4"
                :key="index"
                :index="index - 1"
                :current-step-index="currentStepIndex"
                class="clickable"
                @clicked="goToStep(index - 1)"
              />
            </div>
          </v-col>
          <v-col
            class="col-12 text-right align-self-center"
            :class="{
              'col-sm-12 mb-sm-1': currentStepIndex >= enumOnboarding.SELECT_PLAN_STEP,
              'col-sm-auto': currentStepIndex < enumOnboarding.SELECT_PLAN_STEP,
              'buttons-disposition-mobile': $breakpoint.mobileAndDown,
            }"
          >
            <v-btn
              v-show="hasToShowBackButton"
              ripple
              depressed
              :block="$breakpoint.mobileAndDown"
              :height="$breakpoint.mobileAndDown ? '44px' : '36px'"
              color="grey lighten-5"
              class="primary--text heading heading-s-small align-self-center unaltered-text-cap letter-spacing-normal shadow-light-button px-4 mr-sm-4 mt-4 mt-sm-0"
              @click="goStepBack"
            >
              Back
            </v-btn>
            <v-btn
              v-show="currentStepIndex === enumOnboarding.INTRO"
              ripple
              :text="$breakpoint.tabletAndUp"
              depressed
              :block="$breakpoint.mobileAndDown"
              :height="$breakpoint.mobileAndDown ? '44px' : '36px'"
              :color="$breakpoint.mobileAndDown ? 'grey lighten-5' : ''"
              class="primary--text heading heading-s-small align-self-center unaltered-text-cap mt-4 mt-sm-0 mr-sm-4"
              :class="{ 'shadow-light-button': $breakpoint.mobileAndDown }"
              @click="skipOnboarding"
            >
              Skip
            </v-btn>
            <v-btn
              ripple
              depressed
              :block="$breakpoint.mobileAndDown"
              :height="$breakpoint.mobileAndDown ? '44px' : '36px'"
              color="primary white--text"
              class="heading heading-s-small align-self-center unaltered-text-cap shadow-light-button px-6"
              @click="nextStep"
            >
              {{ items[currentStepIndex].btnPrimary }}
            </v-btn>
          </v-col>
          <v-col
            v-show="currentStepIndex < enumOnboarding.SELECT_PLAN_STEP && $breakpoint.mobileAndDown"
            class="justify-center mb-8"
            :class="[
              { 'd-flex': currentStepIndex < enumOnboarding.SELECT_PLAN_STEP && $breakpoint.mobileAndDown },
              $breakpoint.mobileAndUp ? 'mt-8' : 'mt-6',
            ]"
            cols="12"
            sm="4"
            align-self="center"
          >
            <div class="d-flex">
              <DotComponent
                v-for="index in 4"
                :key="index"
                :index="index - 1"
                :current-step-index="currentStepIndex"
                class="clickable"
                @clicked="goToStep(index - 1)"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      v-if="hasToShowSelectPlanStep"
      no-gutters
      class="justify-space-around fix-last-step-overflow pa-6 pa-sm-10 mb-0"
      :class="{ 'no-overflow-y': hasToShowSelectPlanStep && $breakpoint.tabletAndUp }"
    >
      <SubscriptionOnboardingComponent
        @confirm-plan-selection="confirmPlanSelection"
        @select-plan="selectPlan"
      />
    </v-row>
    <v-row
      v-if="hasToShowNavbar"
      no-gutters
    >
      <v-app-bar
        v-if="
          $breakpoint.mobileAndDown &&
          (currentStepIndex === enumOnboarding.CHECKOUT_STEP ||
            currentStepIndex === enumOnboarding.SPECIALTY_STEP ||
            currentStepIndex === enumOnboarding.KEYWORDS_STEP)
        "
        class="app-bar"
        app
        color="var(--v-background-base)"
        flat
      >
        <ph-caret-left
          class="clickable"
          weight="thin"
          size="24"
          color="var(--v-grey-darken4)"
          @click="goToStep(currentStepIndex - 1)"
        />
        <h6
          class="text text-l-large-regular grey--text text--darken-3 ml-2"
          @click="goToStep(currentStepIndex - 1)"
        >
          {{ backNavbarButtonTextToShow }}
        </h6>
      </v-app-bar>
    </v-row>
    <v-row
      v-if="hasToShowCheckoutStep"
      no-gutters
      class="justify-space-around fix-last-step-overflow pa-6 pa-sm-10 mb-0"
    >
      <v-col
        v-if="$breakpoint.tabletAndUp"
        class="col-12 text-left d-flex mb-sm-6"
      >
        <ph-caret-left
          weight="thin"
          size="24"
          class="clickable grey--text text--lighten-1 mr-2"
          @click="goToStep(currentStepIndex - 1)"
        />
        <h3 class="text text-l-large-bold grey--text text--darken-1">{{ planSelected.title }} plan</h3>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="pr-sm-3 mt-12 mt-sm-0"
      >
        <PaymentSummaryComponent
          :plan-selected="planSelected"
          @use-promo-code="usePromoCode"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="pl-sm-3"
      >
        <WrapperPaymentMethodComponent
          v-show="hasToShowCheckoutStep && paymentServiceLoaded"
          :item-selected="planSelected"
          :is-onboarding="true"
          :promo-code="promoCode"
          @loaded="paymentServiceLoaded = true"
          @payment-success="paymentSuccess"
        />
        <ProgressBarComponent
          v-if="hasToShowCheckoutStep && !paymentServiceLoaded"
          :title="'payment form'"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="hasToShowSpecialtyStep"
      class="justify-space-around fix-last-step-overflow pa-6 pa-sm-10 mb-0"
      no-gutters
    >
      <SpecialtyListComponent
        :check-for-guest-specialties="true"
        @show-again-welcome-steps="goStepBack"
        @finish-specialties-selection="nextStep"
      />
    </v-row>
    <v-row
      v-if="hasToShowKeywordsPanel"
      class="justify-space-around fix-last-step-overflow pa-6 pa-sm-10 mb-0"
      no-gutters
    >
      <KeywordListComponent
        :has-to-show-toast="true"
        :has-to-use-inner-scroll="true"
        @show-again-welcome-steps="goStepBack"
        @skip-keywords-selection="handleSkipKeywordsSelection"
        @finish-keywords-selection="handleFinishKeywordsSelection"
      />
    </v-row>
    <v-row
      v-if="hasToShowEthicsPanel"
      class="justify-space-around fix-last-step-overflow no-overflow-y pa-6 pa-sm-10 mb-0"
      no-gutters
    >
      <v-col cols="12">
        <EthicsComponent @next-step="nextStep" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OnboardingImagesHandlerComponent from '@/components/onboarding/images/OnboardingImagesHandlerComponent';
import SubscriptionOnboardingComponent from '@/components/subscriptions/SubscriptionOnboardingComponent';
import WrapperPaymentMethodComponent from '@/components/payment/WrapperPaymentMethodComponent';
import PaymentSummaryComponent from '@/components/payment/PaymentSummaryComponent';
import SpecialtyListComponent from '@/components/specialties/SpecialtyListComponent';
import KeywordListComponent from '@/components/keywords/KeywordListComponent';
import DotComponent from '@/components/common/DotComponent';
import ProgressBarComponent from '@/components/common/ProgressBarComponent';
import { PhCaretLeft } from 'phosphor-vue';
import EthicsComponent from '@/components/common/EthicsComponent';

export default {
  components: {
    DotComponent,
    ProgressBarComponent,
    OnboardingImagesHandlerComponent,
    SubscriptionOnboardingComponent,
    WrapperPaymentMethodComponent,
    PaymentSummaryComponent,
    SpecialtyListComponent,
    KeywordListComponent,
    PhCaretLeft,
    EthicsComponent,
  },
  props: ['currentRoute', 'currentUser'],
  data: () => ({
    currentStepIndex: 0,
    items: [
      {
        id: '0',
        title: 'Welcome to Acapedia Professionals',
        desc: 'Where the brightest minds of the world share knowledge through evidenced based data while fulfilling professional requirements.',
        btnPrimary: 'Learn more',
        btnSecondary: 'Skip',
      },
      {
        id: '1',
        title: 'Explore our exclusive content',
        desc: 'Find the premium course or article that is most appropriate for your medical specialty or to meet specific state requirements.',
        btnPrimary: 'Next',
        btnSecondary: 'Back',
      },
      {
        id: '2',
        title: 'Validate your knowledge',
        desc: 'Read and learn from the content you selected, while taking quizzes to verify your understanding.',
        btnPrimary: 'Next',
        btnSecondary: 'Back',
      },
      {
        id: '3',
        title: 'Get your CME credit!',
        desc: 'Get CME credit and, depending on your ABMS board, MOC credit may also be awarded through an accredited provider.',
        btnPrimary: 'Select plan',
        btnSecondary: 'Back',
      },
      { id: '4', title: 'Select a plan', btnPrimary: 'Select plan', btnSecondary: 'Back' },
      { id: '5', title: 'Checkout', btnPrimary: 'Confirm payment' },
      {
        id: '6',
        title: 'Now select your specialty and subspecialties',
        titleAlter: 'Now select your specialty and subspecialties',
        desc: 'You will obtain better suggestions based on the selection of your areas of interest.',
        btnPrimary: 'Select specialty',
        btnSecondary: 'Back',
      },
      { id: '7', title: 'Specialties' },
      { id: '8', title: 'Interests' },
      { id: '9', title: 'Ethics' },
      {
        id: '10',
        title: 'You’re ready to earn CME credits!',
        desc: 'Find interesting articles or premium courses in your feed and earn CME credits. ',
        btnPrimary: 'Go to feed',
      },
    ],
    enumOnboarding: {
      INTRO: 0,
      FIRST: 1,
      SECOND: 2,
      THIRD: 3,
      SELECT_PLAN_STEP: 4,
      CHECKOUT_STEP: 5,
      POST_CHECKOUT: 6,
      SPECIALTY_STEP: 7,
      KEYWORDS_STEP: 8,
      ETHICS_STEP: 9,
      FINAL: 10,
    },
    descriptionClasses: 'descriptions mt-2 mb-4 text text-l-large-regular',
    animatedClass: 'animate-text',
    mountedDone: false,
    touchendX: 0,
    touchstartX: 0,
    touchendY: 0,
    touchstartY: 0,
    touchEventsDone: false,
    planSelected: null,
    showDiscountCodeBox: false,
    discountCode: null,
    paymentServiceLoaded: false,
    checkoutStepDone: false,
    isLoading: true,
    promoCode: null,
  }),
  computed: {
    ...mapGetters('feed', ['isOnboardingFinished', 'isOnboardingRequestDone']),
    hasToShowOnboarding() {
      if (this.isLoading) {
        return false;
      }

      if (
        !this.isOnboardingFinished &&
        this.isOnboardingRequestDone &&
        this.currentUser &&
        (this.currentRoute === 'home' || this.currentRoute === '/')
      ) {
        this.setGeneralVeil(true);
        document.querySelector(':root').style['overflow-y'] = 'hidden';
        return true;
      } else {
        this.setGeneralVeil(false);
        document.querySelector(':root').style['overflow-y'] = 'initial';
      }

      return false;
    },
    hasToShowWelcomeSteps() {
      return (
        this.currentStepIndex < this.enumOnboarding.SELECT_PLAN_STEP ||
        this.currentStepIndex === this.enumOnboarding.POST_CHECKOUT ||
        this.currentStepIndex === this.enumOnboarding.FINAL
      );
    },
    hasToShowLastLearnMoreStep() {
      return this.currentStepIndex === this.enumOnboarding.THIRD;
    },
    hasToShowSelectPlanStep() {
      return this.currentStepIndex === this.enumOnboarding.SELECT_PLAN_STEP;
    },
    hasToShowCheckoutStep() {
      return this.currentStepIndex === this.enumOnboarding.CHECKOUT_STEP;
    },
    hasToShowSpecialtyStep() {
      return this.currentStepIndex === this.enumOnboarding.SPECIALTY_STEP;
    },
    hasToShowKeywordsPanel() {
      return this.currentStepIndex === this.enumOnboarding.KEYWORDS_STEP;
    },
    hasToShowEthicsPanel() {
      return this.currentStepIndex === this.enumOnboarding.ETHICS_STEP;
    },
    hasToShowBackButton() {
      const { INTRO, FINAL, SELECT_PLAN_STEP, POST_CHECKOUT } = this.enumOnboarding;

      if (this.$breakpoint.tabletAndUp) {
        return ![INTRO, FINAL, SELECT_PLAN_STEP, POST_CHECKOUT].includes(this.currentStepIndex);
      }

      if (this.$breakpoint.mobileAndDown) {
        return ![INTRO, FINAL, SELECT_PLAN_STEP, POST_CHECKOUT].includes(this.currentStepIndex);
      }

      return false;
    },
    hasToShowNavbar() {
      const { CHECKOUT_STEP, KEYWORDS_STEP } = this.enumOnboarding;

      if (this.$breakpoint.mobileAndDown) {
        return [CHECKOUT_STEP, KEYWORDS_STEP].includes(this.currentStepIndex);
      }

      return false;
    },
    backNavbarButtonTextToShow() {
      if (this.currentStepIndex === this.enumOnboarding.CHECKOUT_STEP) {
        return this.planSelected ? `Back to Plans` : 'N/A';
      }

      if (this.currentStepIndex === this.enumOnboarding.SPECIALTY_STEP) {
        return 'Select specialties';
      }

      if (this.currentStepIndex === this.enumOnboarding.KEYWORDS_STEP) {
        return 'Back to Specialties';
      }

      return 'Back';
    },
    hasToAdjustImagesHeadingForSEPhones() {
      return this.currentStepIndex < this.enumOnboarding.SELECT_PLAN_STEP && this.$breakpoint.smallMobileAndDown;
    },
    titleForSteps() {
      if (!this.planSelected?.isFree && this.items[this.currentStepIndex].titleAlter) {
        return this.items[this.currentStepIndex].titleAlter;
      }

      return this.items[this.currentStepIndex].title;
    },
    titleClassName() {
      if (this.$breakpoint.smallMobileAndDown) {
        return this.buildTitleClassNameForSE();
      }

      if (this.$breakpoint.mobileOnly) {
        return this.buildTitleCLassNameForPhone();
      }

      if (this.$breakpoint.tabletAndUp) {
        return this.buildTitleClassNameForTabletAndUp();
      }

      return '';
    },
    calculateClassForNumber() {
      if (this.$breakpoint.smallMobileAndDown) {
        return 'heading-m-small';
      }

      if (this.$breakpoint.mobileOnly) {
        return 'heading-m-large';
      }

      if (this.$breakpoint.tabletAndUp) {
        return 'heading-m-small';
      }

      return '';
    },
    totalPayment() {
      return this.planSelected.price;
    },
  },
  updated() {
    if (this.$refs.onboardingPanel && !this.touchEventsDone) {
      const that = this;
      this.$refs.onboardingPanel.addEventListener(
        'touchstart',
        function (event) {
          that.touchstartX = event.changedTouches[0].screenX;
          that.touchstartY = event.changedTouches[0].screenY;
        },
        false,
      );

      this.$refs.onboardingPanel.addEventListener(
        'touchend',
        function (event) {
          that.touchendX = event.changedTouches[0].screenX;
          that.touchendY = event.changedTouches[0].screenY;

          that.handleGesture();
        },
        false,
      );

      this.touchEventsDone = true;
    }

    if (this.$refs.descriptions && !this.mountedDone) {
      this.$refs.descriptions.addEventListener('animationend', () => {
        this.$refs.descriptions.className = this.descriptionClasses;
      });

      this.mountedDone = true;
    }
  },
  async mounted() {
    const response = await this.getUserSubscription();
    const alreadyHasFreeSubscription = response?.data?.alreadyHasFreeSubscription;

    if (!alreadyHasFreeSubscription) {
      await this.postConfirmFreeSubscription({ id: this.currentUser.id });
    }
    this.currentStepIndex = this.enumOnboarding.FINAL;

    this.$eventNotifier.notify('view_welcome_onboarding', {
      eventCategory: 'Welcome Onboarding',
    });

    this.isLoading = false;
  },
  methods: {
    ...mapActions('feed', ['finishOnboarding']),
    ...mapActions('menu', ['setGeneralVeil']),
    ...mapActions('subscriptions', ['getUserSubscription', 'postConfirmFreeSubscription']),
    nextStep() {
      if (this.hasToShowLastLearnMoreStep) {
        this.$eventNotifier.notify('complete_learn_more_onboarding', {
          eventCategory: 'Welcome Onboarding',
        });
      }

      if (
        this.currentStepIndex === this.enumOnboarding.SELECT_PLAN_STEP &&
        this.planSelected &&
        this.planSelected.isFree
      ) {
        this.$eventNotifier.notify('view_post_checkout_onboarding', {
          eventCategory: 'Welcome Onboarding',
          eventLabel: this.planSelected.title,
        });

        this.postConfirmFreeSubscription({ id: this.currentUser.id });
        this.currentStepIndex = this.enumOnboarding.POST_CHECKOUT;
        return;
      }

      if (this.currentStepIndex === this.enumOnboarding.SELECT_PLAN_STEP && this.planSelected) {
        this.$eventNotifier.notify('view_checkout_onboarding', {
          eventCategory: 'Welcome Onboarding',
          eventLabel: this.planSelected.title,
        });

        this.currentStepIndex++;
        return;
      }

      if (this.currentStepIndex === this.enumOnboarding.CHECKOUT_STEP && !this.checkoutStepDone) {
        return;
      }

      if (this.currentStepIndex === this.enumOnboarding.FINAL) {
        this.$eventNotifier.notify('complete_welcome_onboarding', {
          eventCategory: 'Welcome Onboarding',
        });

        this.finishOnboardingFlow();
      }

      this.currentStepIndex = this.enumOnboarding.FINAL;

      if (this.$refs.descriptions) {
        this.$refs.descriptions.className = `${this.descriptionClasses} ${this.animatedClass}`;
      }
    },
    goStepBack() {
      if (this.enumOnboarding.CHECKOUT_STEP === this.currentStepIndex) {
        this.checkoutStepDone = false;
        this.planSelected = null;
        this.paymentServiceLoaded = false;
      }

      if (
        (this.currentStepIndex > this.enumOnboarding.INTRO &&
          this.currentStepIndex < this.enumOnboarding.SELECT_PLAN_STEP) ||
        this.currentStepIndex === this.enumOnboarding.SPECIALTY_STEP ||
        this.currentStepIndex === this.enumOnboarding.KEYWORDS_STEP ||
        this.currentStepIndex === this.enumOnboarding.CHECKOUT_STEP
      ) {
        this.currentStepIndex--;
      }
    },
    closeOnboarding() {
      this.finishOnboardingFlow();
    },
    finishOnboardingFlow() {
      this.finishOnboarding();
      this.setGeneralVeil(false);
      document.querySelector(':root').style['overflow-y'] = 'initial';
    },
    goToStep(index) {
      if (index < this.currentStepIndex && this.enumOnboarding.CHECKOUT_STEP === this.currentStepIndex) {
        this.checkoutStepDone = false;
        this.planSelected = null;
        this.paymentServiceLoaded = false;
      }

      this.currentStepIndex = index;
      if (this.$refs.descriptions) {
        this.$refs.descriptions.className = `${this.descriptionClasses} ${this.animatedClass}`;
      }
    },
    skipOnboarding() {
      this.$eventNotifier.notify('skip_learn_more_onboarding', {
        eventCategory: 'Welcome Onboarding',
      });

      this.currentStepIndex = this.enumOnboarding.SELECT_PLAN_STEP;
    },
    handleGesture() {
      const passThresholdTolerance =
        Math.abs(this.touchendY - this.touchstartY) < 100 && Math.abs(this.touchendX - this.touchstartX) > 50;

      if (this.$breakpoint.tabletAndDown) {
        if (this.touchendX < this.touchstartX && passThresholdTolerance) {
          this.nextStep();
        }

        if (this.touchendX > this.touchstartX && passThresholdTolerance) {
          this.goStepBack();
        }
      }
    },
    selectPlan(selectedPlanInfo) {
      this.planSelected = selectedPlanInfo;
    },
    confirmPlanSelection() {
      this.nextStep();
    },
    paymentSuccess() {
      try {
        this.$eventNotifier.purchase({
          currency: 'USD',
          transactionId: `${this.currentUser.id}-${this.planSelected.priceHash}-${new Date().toISOString()}`,

          value: this.planSelected.price,
          items: [
            {
              id: this.planSelected.priceHash,
              itemName: this.planSelected.title,
              itemCategory: 'subscription',
              quantity: 1,
              price: this.planSelected.price,
            },
          ],
        });
        this.$eventNotifier.notify('view_post_checkout_onboarding', {
          eventCategory: 'Welcome Onboarding',
          eventLabel: this.planSelected.title,
        });
      } catch (error) {
        this.$toasted.global.showError({ message: error.response.data?.message || error.message });
      }

      this.checkoutStepDone = true;
      this.getUserSubscription();
      this.nextStep();
    },
    addDiscountCode() {
      this.showDiscountCodeBox = true;
    },
    buildTitleClassNameForSE() {
      const isStepBeforeSelectPlan = this.currentStepIndex < this.enumOnboarding.SELECT_PLAN_STEP;
      const isFinalStep = this.currentStepIndex === this.enumOnboarding.FINAL;

      if (isStepBeforeSelectPlan || isFinalStep) {
        return 'heading-m-small onboarding-title-regular-mobile';
      }

      const isSelectPlanStep = this.currentStepIndex === this.enumOnboarding.SELECT_PLAN_STEP;
      const isPostCheckoutStep = this.currentStepIndex === this.enumOnboarding.POST_CHECKOUT;

      if (isSelectPlanStep || isPostCheckoutStep) {
        return 'heading-l-small';
      }

      return '';
    },
    buildTitleCLassNameForPhone() {
      const isStepSelectPlanOrAfter = this.currentStepIndex >= this.enumOnboarding.SELECT_PLAN_STEP;
      if (isStepSelectPlanOrAfter) {
        return 'heading-l-large onboarding-title-regular-mobile';
      }

      const isStepAfterIntroInitialStep = this.currentStepIndex > this.enumOnboarding.INTRO;
      const isStepBeforeSelectPlan = this.currentStepIndex < this.enumOnboarding.SELECT_PLAN_STEP;
      const hasToAddMarginTop = isStepAfterIntroInitialStep && isStepBeforeSelectPlan;

      return `heading-m-large onboarding-title-regular-mobile ${hasToAddMarginTop ? 'mt-4' : ''}`;
    },
    buildTitleClassNameForTabletAndUp() {
      if (
        ![
          this.enumOnboarding.INTRO,
          this.enumOnboarding.SELECT_PLAN_STEP,
          this.enumOnboarding.POST_CHECKOUT,
          this.enumOnboarding.FINAL,
        ].includes(this.currentStepIndex)
      ) {
        return 'heading-m-small onboarding-title-regular-mobile';
      }

      const isSelectPlanStep = this.currentStepIndex === this.enumOnboarding.SELECT_PLAN_STEP;
      if (isSelectPlanStep) {
        return 'heading-m-large onboarding-title-regular-mobile pl-sm-15 pl-lg-8';
      }

      return 'heading-m-large onboarding-title-regular-mobile';
    },
    usePromoCode(promoCode) {
      this.promoCode = promoCode;
    },
    handleSkipKeywordsSelection() {
      this.$eventNotifier.notify('skip_keywords_selection', {
        eventCategory: 'Welcome Onboarding',
      });

      this.nextStep();
    },
    handleFinishKeywordsSelection() {
      this.$eventNotifier.notify('complete_keywords_selection', {
        eventCategory: 'Welcome Onboarding',
      });

      this.nextStep();
    },
  },
};
</script>

<style scoped>
.onboarding-panel {
  position: fixed;
  background-color: var(--v-background-base);
  z-index: 99;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.07);
}
.content-onboarding {
  flex-direction: column;
  display: flex;
}
.onboarding-panel p.descriptions {
  height: 72px;
}
.buttons-disposition-mobile {
  display: flex;
  flex-direction: column-reverse;
}
.fix-last-step-overflow {
  overflow-x: hidden;
  overflow-y: scroll;
}
.adjust-images-for-tablet-and-up {
  display: flex;
  align-items: center;
}
@keyframes keyframe-animation-display {
  from {
    opacity: 0;
    transform: translateX(15px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
.animate-text {
  animation-name: keyframe-animation-display;
  animation-duration: 1s;
  animation-iteration-count: 1;
}
.number-step-box {
  background: #ffffff;
  border-radius: 32px;
  width: 41px;
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fixed-actions-nonmobile {
  position: absolute;
  z-index: 5;
  bottom: 0px;
  right: 0px;
  left: 0px;
}
@media (max-width: 600px) {
  .onboarding-panel-size {
    width: 100%;
    height: 100%;
  }
  .onboarding-panel-size > .row {
    background-color: var(--v-background-base);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .onboarding-panel-size {
    height: 27vh;
    min-height: 292px;
    width: 87.5%;
    left: 0;
    right: 0;
    margin: auto;
    top: calc(50% - 146px);
  }
}
@media (min-width: 1024px) and (max-width: 1263px) {
  .onboarding-panel-size {
    height: 30vh;
    min-height: 260px;
    width: 792px !important;
    left: 0;
    right: 0;
    margin: auto;
    top: calc(50% - 130px);
  }
}
@media (min-width: 1264px) {
  .onboarding-panel-size {
    height: 25vh;
    min-height: 268px;
    width: 55%;
    max-width: 792px;
    left: 0;
    right: 0;
    margin: auto;
    top: calc(50% - 134px);
  }
}
@media (max-width: 320px) {
  .onboarding-title-regular-mobile {
    flex: 80%;
  }
}
@media (min-width: 321px) and (max-width: 600px) {
  .onboarding-title-regular-mobile {
    flex: 100%;
  }
  .number-step-box {
    width: 51px;
    height: 51px;
  }
}
/* Default adjust */
@media (min-width: 600px) {
  .content-onboarding {
    display: block;
    position: relative;
  }
  .panel-size-increased-on-select-plan {
    height: 520px;
    top: calc(50% - 260px);
  }
  .panel-size-increased-on-select-plan-isLifetime {
    height: 660px;
    top: calc(50% - 330px);
  }
  .panel-size-increased-on-specialties {
    height: 98vh;
    top: calc(50% - 49vh);
  }
  .panel-size-increased-on-keywords {
    height: 98vh;
    top: calc(50% - 49vh);
  }
  .panel-size-increased-on-ethics {
    height: 412px;
    top: calc(50% - 206px);
  }
}
/* Default adjust for all generic non-portable devices */
@media (min-width: 600px) and (min-height: 600px) {
  .panel-size-increased-on-checkout {
    height: 90vh;
    top: calc(50% - 49vh);
  }
  .panel-size-increased-on-specialties {
    height: 90vh;
    top: calc(50% - 45vh);
  }
  .panel-size-increased-on-keywords {
    height: 90vh;
    top: calc(50% - 49vh);
  }
  .panel-size-increased-on-ethics {
    height: 412px;
    top: calc(50% - 206px);
  }
}
/* Only tablets */
@media (min-width: 768px) and (min-height: 1024px) and (orientation: portrait) {
  .panel-size-increased-on-checkout {
    height: auto;
    top: calc(50% - 450px);
  }
  .panel-size-increased-on-specialties {
    height: 90vh;
    top: calc(50% - 45vh);
  }
  .panel-size-increased-on-keywords {
    height: 50vh;
    top: calc(50% - 25vh);
  }
  .panel-size-increased-on-ethics {
    height: 484px;
    top: calc(50% - 242px);
  }
}
/* Odd desktops and tablets in landscape mode */
@media (min-width: 600px) and (min-height: 500px) and (orientation: landscape) {
  .panel-size-increased-on-checkout {
    height: 90vh;
    top: calc(50% - 45vh);
  }
  .panel-size-increased-on-specialties {
    height: 90vh;
    top: calc(50% - 45vh);
  }
  .panel-size-increased-on-keywords {
    height: 70vh;
    top: calc(50% - 35vh);
  }
  .panel-size-increased-on-ethics {
    height: 460px;
    top: calc(50% - 230px);
  }
}
/* Regular small desktops */
@media (min-width: 1024px) and (min-height: 720px) and (orientation: landscape) {
  .panel-size-increased-on-checkout {
    height: 90vh;
    top: calc(50% - 45vh);
  }
  .panel-size-increased-on-specialties {
    height: 90vh;
    top: calc(50% - 45vh);
  }
  .panel-size-increased-on-keywords {
    height: 70vh;
    top: calc(50% - 35vh);
  }
  .panel-size-increased-on-ethics {
    width: 771px;
    height: 460px;
    top: calc(50% - 230px);
  }
}
/* Large tablets in landscape mode or medium desktops and up */
@media (min-width: 1024px) and (min-height: 1024px) and (orientation: landscape) {
  .panel-size-increased-on-checkout {
    height: auto;
    top: calc(50% - 450px);
  }
  .panel-size-increased-on-specialties {
    height: 70vh;
    top: calc(50% - 35vh);
  }
  .panel-size-increased-on-keywords {
    height: 50vh;
    top: calc(50% - 25vh);
  }
  .panel-size-increased-on-ethics {
    height: 436px;
    top: calc(50% - 218px);
  }
}
.fixed-bottom-mobile {
  position: relative;
  z-index: 5;
  width: calc(100vw - 48px);
  margin-left: 0;
  margin-right: 0;
  bottom: -24px;
}
</style>
